import styled from "@emotion/styled";

import {
  MDSIcon,
  MDSIconKind,
  MDSTextField,
  MDSTextFieldSlotName,
  MDSTextFieldVariant,
} from "@/mds";

export const AgentFilterSearchField = ({
  ariaLabel,
  placeholder,
  value,
  onChange,
}: {
  ariaLabel: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}) => (
  <StyledField
    aria-label={ariaLabel}
    placeholder={placeholder}
    value={value}
    variant={MDSTextFieldVariant.Filter}
    showClearTextButton
    onClearText={() => {
      onChange("");
    }}
    onChange={onChange}
  >
    <MDSIcon kind={MDSIconKind.Search} size={14} slot={MDSTextFieldSlotName.LeftAddon} />
  </StyledField>
);

const StyledField = styled(MDSTextField)`
  min-width: 240px;
  width: min(320px, 100%);
`;
